(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shipping-calculator"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-brivar-shipping-calculator]').forEach((calculator) => {
        if (calculator.dataset.initialized === 'true') return;
        calculator.dataset.initialized = 'true';

        const form = calculator.querySelector('.brivar-shipping__form');
        const input = calculator.querySelector('.brivar-shipping__input');
        const result = calculator.querySelector('.brivar-shipping__result');
        const options = calculator.querySelector('[data-shipping-options]');
        const error = calculator.querySelector('[data-shipping-error]');

        input?.addEventListener('input', () => {
          const digits = input.value.replace(/\D/g, '').slice(0, 8);
          input.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
        });

        form?.addEventListener('submit', (event) => {
          event.preventDefault();
          const isValid = (input?.value || '').replace(/\D/g, '').length === 8;

          result.hidden = false;
          if (options) options.hidden = !isValid;
          if (error) error.hidden = isValid;
          if (input) input.setAttribute('aria-invalid', String(!isValid));
        });
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
